import { createFileRoute } from '@tanstack/react-router'
import { format } from 'date-fns'

import { fetchMonthlyCustomerReportDailyReports } from '@/features/monthly-customer-reports/api'
import { getMonthlyCustomerReportQueryOptions } from '@/features/monthly-customer-reports/query-options'
import { calculateReportPeriod } from '@/libs/utils/date-utils'

export const Route = createFileRoute(
  '/_protected/$tenantKey/_performance_managements/monthly-customer-reports/$monthlyCustomerReportId/'
)({
  loader: async ({
    abortController,
    params: { tenantKey, monthlyCustomerReportId },
    context: { auth, queryClient }
  }) => {
    // まず月次レポート情報を取得
    const monthlyCustomerReport = await queryClient.fetchQuery({
      ...getMonthlyCustomerReportQueryOptions({
        tenantKey,
        monthlyCustomerReportId
      }),
      // route.tsx で取得処理を行なってるため staleTime を設定して重複リクエストを防ぐ
      staleTime: 500
    })

    // レポート作成時の締日を考慮した期間を計算
    const { operatingYearMonth } = monthlyCustomerReport
    let operatingDateFrom: string | undefined
    let operatingDateTo: string | undefined

    if (monthlyCustomerReport.closingDate) {
      // 締日が設定されている場合は締日を考慮した期間計算
      const { startDate, endDate } = calculateReportPeriod(
        new Date(operatingYearMonth),
        monthlyCustomerReport.closingDate,
        monthlyCustomerReport.oldClosingDate ?? undefined,
        monthlyCustomerReport.closingDateEffectiveFrom
          ? new Date(monthlyCustomerReport.closingDateEffectiveFrom)
          : undefined
      )
      operatingDateFrom = format(startDate, 'yyyy-MM-dd')
      operatingDateTo = format(endDate, 'yyyy-MM-dd')
    }

    // 計算した期間で日次レポートを取得
    const dailyReports = await fetchMonthlyCustomerReportDailyReports(
      {
        tenantKey,
        monthlyCustomerReportId,
        query: {
          operatingDateFrom,
          operatingDateTo
        }
      },
      abortController.signal
    )

    return {
      authUser: auth.user,
      monthlyCustomerReport,
      dailyReports
    }
  }
})
